import { action, makeObservable, observable } from 'mobx';

import { Store } from '@servicetitan/react-ioc';

import { RequestState } from '../utils/request-states';

export const DEFAULT_REQUEST_KEY = 'defaultKey';

export class RequestManager extends Store {
    @observable private requestStates = new Map<string, RequestState>();
    @observable private abortControllers = new Map<string, AbortController>();

    constructor() {
        super();
        makeObservable(this);
    }

    @action resetAbortController = (key = DEFAULT_REQUEST_KEY) => {
        this.abortControllers.set(key, new AbortController());
    };

    cancelRequest = (key = DEFAULT_REQUEST_KEY) => {
        this.abortControllers.get(key)?.abort();
    };

    getAbortController = (key = DEFAULT_REQUEST_KEY) => {
        return this.abortControllers.get(key);
    };

    @action setRequestState = (key = DEFAULT_REQUEST_KEY, requestState = RequestState.Idle) => {
        this.requestStates.set(key, requestState);
    };

    getRequestState = (key = DEFAULT_REQUEST_KEY) => {
        return this.requestStates.get(key) ?? RequestState.Idle;
    };
}
